"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var React = require("react");
var popover_1 = require("wix-ui-core/dist/src/components/popover");
var random_1 = require("../../common/random");
var Popover_st_css_1 = require("./Popover.st.css");
var types_1 = require("./types");
var ReffedPopover = function (props, ref) {
    var triggerAction = props.triggerAction, wiredToSiteColors = props.wiredToSiteColors, children = props.children, className = props.className, shown = props.shown, rest = __rest(props, ["triggerAction", "wiredToSiteColors", "children", "className", "shown"]);
    var _a = React.useState(false), isShown = _a[0], setIsShown = _a[1];
    var isControlled = React.useRef(typeof shown !== 'undefined' ||
        triggerAction === types_1.PopoverTriggerAction.click);
    var id = React.useRef(random_1.generateKey('popover'));
    var isVertical = React.useMemo(function () {
        return ['bottom', 'top'].some(function (position) {
            return new RegExp(position).test(props.placement);
        });
    }, [props.placement]);
    var _b = React.Children.toArray(children).sort(function (e1, e2) {
        if (![e1, e2].every(React.isValidElement)) {
            return;
        }
        return e1.type === exports.Popover.Element ? -1 : 0;
    }), Element = _b[0], Content = _b[1];
    return (React.createElement(popover_1.Popover, __assign({ ref: ref, showArrow: true, shown: shown !== null && shown !== void 0 ? shown : isShown, moveBy: isVertical ? { y: 8 } : { x: 8 }, className: Popover_st_css_1.st(Popover_st_css_1.classes.root, { wired: wiredToSiteColors }, className) }, _getCoreProps(isControlled), rest),
        React.cloneElement(Element, {}, React.cloneElement(Element.props.children, _getTriggerProps(isControlled))),
        Content));
    function _getTriggerProps(_isControlled) {
        switch (triggerAction) {
            case types_1.PopoverTriggerAction.hover:
                return __assign({ 'aria-describedby': id }, (_isControlled.current
                    ? {}
                    : {
                        onFocus: _handleOpen,
                        onBlur: _handleClose,
                    }));
            case types_1.PopoverTriggerAction.click:
            default:
                return {};
        }
    }
    function _getCoreProps(_isControlled) {
        switch (triggerAction) {
            case types_1.PopoverTriggerAction.click:
                return {
                    role: 'dialog',
                    appendTo: 'parent',
                };
            case types_1.PopoverTriggerAction.hover:
            default:
                return __assign(__assign({}, (_isControlled.current
                    ? {}
                    : {
                        onMouseEnter: _handleOpen,
                        onMouseLeave: _handleClose,
                    })), { role: 'tooltip', id: id.current });
        }
    }
    function _handleOpen() {
        setIsShown(true);
    }
    function _handleClose() {
        setIsShown(false);
    }
};
exports.Popover = Object.assign(React.forwardRef(ReffedPopover), {
    Element: popover_1.Popover.Element,
    Content: popover_1.Popover.Content,
});
exports.Popover.defaultProps = {
    triggerAction: types_1.PopoverTriggerAction.hover,
    wiredToSiteColors: true,
    placement: 'top',
};
exports.Popover.displayName = 'Popover';
//# sourceMappingURL=Popover.js.map